<nav class="navbar">
  <div class="navbar-container">
    <!-- Logo -->
    <div class="navbar-brand">
      <a routerLink="/" style="cursor: pointer;">
        <img src="/loghi/logo_cooprogetti_navbar.png"
                 alt="REFHub"
                 class="logo-image"
                 width="200"
                 height="60" />
      </a>
    </div>

    <!-- Menu principale (desktop) -->
    <div class="navbar-menu">
      <a routerLink="/"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}"
         class="nav-link"
         *ngIf="(isAuthenticated$ | async)">
        <span class="material-symbols-outlined">home</span>
        <span>HOME</span>
      </a>

      <!-- Menu CONFIGURAZIONE annidato -->
      <div
        class="nav-link"
        *ngIf="(isAuthenticated$ | async)"
        (click)="configMenu.toggle($event)">
        <span class="material-symbols-outlined">settings</span>
        <span>CONFIGURAZIONE</span>
      </div>
      <p-menu
        #configMenu
        [model]="configMenuItems"
        [popup]="true"
        [appendTo]="'body'">
      </p-menu>
    </div>

    <!-- Pulsante Supporto (desktop) -->
    <button
      *ngIf="(isAuthenticated$ | async)"
      class="support-button"
      pButton
      type="button"
      [pTooltip]="'Richiesta Supporto'"
      tooltipPosition="bottom"
      (click)="openSupportTicketDialog()"
      aria-label="Supporto"
    >
      <span class="material-symbols-outlined">support_agent</span>
    </button>

    <!-- Menu hamburger (mobile) -->
    <button
      *ngIf="(isAuthenticated$ | async)"
      class="mobile-menu-toggle"
      (click)="toggleMobileMenu($event)"
      aria-label="Menu"
      type="button"
    >
      <span class="material-symbols-outlined">menu</span>
    </button>
    <p-menu
      #mobileMenu
      [model]="mobileMenuItems"
      [popup]="true"
      [appendTo]="'body'"
      [baseZIndex]="100001"
      (onHide)="mobileMenuVisible = false"
    ></p-menu>

    <!-- Menu utente -->
    <div class="navbar-user">
      <!-- Menu utente autenticato -->
      <div class="user-menu" *ngIf="(isAuthenticated$ | async) && currentUser">
        <div
          class="user-chip"
          [ngClass]="getRoleChipClass()"
          (click)="onUserMenuToggle($event)">
          <span class="user-initials">{{ getInitials(currentUser.name) }}</span>
          <span class="user-role">{{ getRoleDisplayName() }}</span>
        </div>
        <p-menu #userMenu [model]="userMenuItems" [popup]="true" [appendTo]="'body'"></p-menu>
      </div>

      <!-- Pulsanti per utenti non autenticati -->
      <div class="auth-buttons" *ngIf="!(isAuthenticated$ | async)">
        <button
          pButton
          type="button"
          icon="pi pi-sign-in"
          [pTooltip]="'Accedi'"
          tooltipPosition="bottom"
          class="p-button-rounded"
          (click)="login()">
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Dialog Richiesta Supporto -->
<app-support-ticket-dialog
  [(visible)]="supportTicketDialogVisible"
></app-support-ticket-dialog>

